import { CardCaracter } from "../../element/Card";
import {useState, useEffect} from 'react'
import { db } from '../../firebase/FirebaseConfig';
import {collection, getDocs, query, where} from 'firebase/firestore';
import { auth } from '../../firebase/FirebaseConfig';
import { Tribe } from '../../List/TribeList'
import Loader from '../../element/Loader'
import {  View, FlatList, ScrollView} from 'react-native-web'



const CharacterSheetList = ({navigation}) => {
    const [characters, setChatacters]=useState([])
    const [flip, setFlip]=useState(false)
    const Master =false
    const user= auth.currentUser

    
useEffect(()=>{
    const unsubscribe = navigation.addListener('focus', () => {
        kimera()
      });
    
     
    
},[navigation])
  
async function kimera(){
    
    let png=[]
    let information=query(collection(db,"personaggi"),where("User","==",user.uid));
    let querySnapshot= await getDocs(information);
          querySnapshot.forEach((docs)=>{png.push(docs.data());});
          setChatacters([...png])
          setFlip(true)   
}
                                
function List(){
  
  return (
       
    <FlatList
     data={characters}
     keyExtractor={(item)=>item.Key}
     showsVerticalScrollIndicator={true}
     
     contentContainerStyle={{marginVertical:15, }}
     renderItem={({ item }) => (
      <ScrollView style={{paddingVertical:15}}>   
     {item.Death? <CardCaracter Name={item.Name} tribeImage={require('../../../assets/skull.png')} Complete={'MORTO'} color2={'grey'} onPress={()=>{navigation.navigate('DetailSheet',{item, Master})}}/>: <CardCaracter Name={item.Name} tribeImage={Tribe[Tribe.findIndex((obj)=>obj.name===item.Tribe)].image} Complete={item.Complete} color2={'#F9BA49'} onPress={()=>{navigation.navigate('DetailSheet',{item, Master})}}/>}
      </ScrollView>
      )}/> 
     
     
  )
}

return(
<View style={{width:'100%', height:'100%'}}>{flip? <List/>:<View style={{width:'100%', height:'100%', alignItems:'center', justifyContent:'center'}}><Loader/></View>}</View>


);}

export default CharacterSheetList

